/* eslint-disable react/react-in-jsx-scope */
/**
 * 新版小友sdk
 * created by liyaoh: 2022-05-31
 */
import { Component, Fragment, createRef } from "react";
import { createPortal } from "react-dom";
import { withRouter } from "react-router-dom";
import { imLogin, GetQuery } from "Pub/js/utils";
import { getStore } from "Pub/js/storageUtils";
import platform from "Pub/js/platform";
import pubSubActions from "Pub/js/pubSubActions";
import Draggable from 'react-draggable';
import { Resizable } from 'react-resizable';
const { PubSub, getLangCode } = platform;
import "./index.less";

class XiaoYou extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            xiaoyouLoaded: false, 
            ctxData: null,
            width: 360,
            height: document.body.clientHeight - 68, 
            left: document.body.clientWidth - 360, 
            top: 68,
        };
        this.xyPubsub = null;
        this.xyFrame = createRef(null);
        this.dragRef = createRef(null);
    }

    componentDidMount() {
        const { im } = JSON.parse(localStorage.getItem('STOREFORSYSTEM'));

        // 简中才显示小友
        if (getLangCode() === 'simpchn') {
            if (im) {
                // 当im存在时 发布订阅拿到数据
                this.xyPubsub = PubSub.subscribe(pubSubActions.global.onLoadIMData, (action, data) => {
                    this.appendSdk(data);
                });
                
            } else {
                imLogin().then(data => {
                    this.appendSdk(data);
                });
            }
        }

        window.addEventListener("hashchange", this.handleHashChange);
        this.initXiaoYou();
    }
    
    componentWillUnmount() {
        PubSub.unsubscribe(this.xyPubsub);
        window.removeEventListener("hashchange", this.handleHashChange);
    }

    render() {
        let { ctxData, height, width, left, top, showMask } = this.state;

        if (!ctxData) {
            return null;
        }

        return <Fragment>
            {createPortal(<span 
                id="workbench-xiaoyou-icon"
                onClick={() => {
                    document.querySelector('#xiaoyou-iframe-wrapper').style.display = 'block';
                    this.xyFrame.current.contentWindow.postMessage({
                        type: 'api',
                        name: 'setVisible',
                        params: [true],
                    });
                }}
            ></span>, document.body)}
            {createPortal(<Draggable 
                bounds="body" 
                handle="#xiaoyou-iframe-drag-handler"
                position={{
                    x: left,
                    y: top,
                }}
                onDrag={this.onDrag}
                onStart={(e) => {
                    e.stopPropagation();
                    document.body.classList.add('user-select-none');
                    this.setState({
                        showMask: true,
                    })
                }}
                onStop={() => {
                    document.body.classList.remove('user-select-none');
                    this.setState({
                        showMask: false,
                    })
                }}
            >
                <Resizable 
                    height={height} 
                    width={width} 
                    onResize={this.onResize}
                    onResizeStart={this.onResizeStart}
                    onResizeStop={this.onResizeStop}
                    minConstraints={[360, 500]}
                    resizeHandles={['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne']}
                >
                    <div id="xiaoyou-iframe-wrapper" style={{ display: 'none', width, height }}>
                        <div 
                            id="xiaoyou-iframe-drag-handler" 
                            style={{ cursor: 'move' }}
                            onMouseEnter={() => {
                                this.resetDragHandlerWidth();
                            }}
                        ></div>
                        
                        <iframe
                            ref={this.xyFrame}
                            id="workbench-xiaoyou-robot-wrapper"
                            src={`/nccloud/resources/workbench/public/common/main/assets/xiaoyou.html?diworkContext=${encodeURIComponent(JSON.stringify({
                                tenantid: ctxData.tenantid,
                                userid: ctxData.yhtuserid,
                                locale: "zh_CN",
                                productLine: "YonBIPPremium",
                                appcode: "yonbippremium",
                                ext: { yht_access_token: ctxData.yht_access_token },
                                vpa_bipfix: ctxData.diworkUrl,
                                isPrefixRobotCard: false,
                                // isPrefixRobotCard: true,
                                // basePrefix: ctxData.diworkUrl,
                            }))}&jsurl=${encodeURIComponent(ctxData.xiaoyousdk)}&cssurl=${encodeURIComponent(ctxData.xiaoyoucss)}`}
                            onLoad={() => {
                                this.setState({ 
                                    xiaoyouLoaded: true,
                                });
                                this.xyFrame.current.contentWindow.addEventListener('message', e => {
                                    let { data } = e;
                                    if (data.type === 'visibilityChange') {
                                        if (data.value) {
                                            document.querySelector('#xiaoyou-iframe-wrapper').style.display = 'block';
                                        } else {
                                            document.querySelector('#xiaoyou-iframe-wrapper').style.display = 'none';
                                        }
                                    }
                                });
                            }}
                        ></iframe>
                    </div>
                </Resizable>
            </Draggable>, document.body)}
            {createPortal(<div
                id="xiaoyou-iframe-mask"
                style={{ 
                    display: showMask ? 'block' : 'none',
                    position: 'fixed',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 9999,
                }}
            ></div>, document.body)}
        </Fragment>;
    }

    handleHashChange = () => {
        this.initXiaoYou();
    };

    appendSdk = ctxData => {
        this.setState({
            ctxData,
        });
    };

    initXiaoYou = () => {
        let { c: appcode, menucode } = GetQuery(this.props.location.search);

        let timer = setInterval(() => {
            if (window.useXiaoYou === false) {
                clearInterval(timer);
            }
    
            if (this.state.xiaoyouLoaded) {
                let info = window.GETBUSINESSINFO ? window.GETBUSINESSINFO() : {},
                    imData = getStore('NCC_IMData') || {},
                    { aiagentcode, productline } = imData,
                    digitalCode = aiagentcode[appcode] || aiagentcode.knowagent || '';
                
                if (digitalCode) {
                    document.querySelector('#workbench-xiaoyou-robot-wrapper').contentWindow.postMessage({
                        type: 'api',
                        name: 'setRobotConfig',
                        params: [{ header: { allAgent: false } }],
                    });
                    document.querySelector('#workbench-xiaoyou-robot-wrapper').contentWindow.postMessage({
                        type: 'api',
                        name: 'setRobot',
                        params: [{ 
                            digitalCode,
                            isAgentCard: false, // 默认是true ，如果是false，智能体显示的模式没有智能体的头像卡片 
                        }],
                    });
                    document.querySelector('#workbench-xiaoyou-robot-wrapper').contentWindow.postMessage({
                        type: 'api',
                        name: 'setChatPageContext',
                        params: [{        
                            isGlobalContext: true,
                            userid: info.userId,
                            groupid: info.groupId,
                            productLine: productline,
                            DomainCode: menucode,
                        }],
                    });

                    // window.xiaoyouRobot.setRobotConfig({ header: { allAgent: false } }); // 是否显示头部的 我的全部智能体
                    // window.xiaoyouRobot.setRobot({ 
                    //     digitalCode,
                    //     isAgentCard: false, // 默认是true ，如果是false，智能体显示的模式没有智能体的头像卡片 
                    // });
                    // window.xiaoyouRobot.setChatPageContext(
                    //     {        
                    //         isGlobalContext: true,
                    //         userid: info.userId,
                    //         groupid: info.groupId,
                    //         productLine: productline,
                    //         DomainCode: menucode,
                    //     },
                    // );
                    document.querySelector('#workbench-xiaoyou-icon').style.display = 'block';
                } else {
                    document.querySelector('#workbench-xiaoyou-robot-wrapper').style.display = 'none';
                    document.querySelector('#workbench-xiaoyou-icon').style.display = 'none';
                }
                    
                clearInterval(timer);
            }
        }, 1000);
    }

    resetDragHandlerWidth = () => {
        let width = this.xyFrame.current.contentWindow.document.querySelector('.xiaoyou-header-left').clientWidth;
        document.querySelector('#xiaoyou-iframe-drag-handler').style.width = width + 'px';
    }

    onDrag = (e, { x, y }) => {
        e.stopPropagation();

        this.setState({
            left: x,
            top: y,
        })
    }

    onResize = (e, {node, size, handle}) => {
        e.stopPropagation();

        if (handle.includes('w')) {
            this.setState({
                left: this.startLeft - (size.width - this.startWidth)
            })
        }
        if (handle.includes('n')) {
            this.setState({
                top: this.startTop - (size.height - this.startHeight)
            })
        }
        this.setState({ width: size.width, height: size.height });
    };

    onResizeStart = (e) => {
        e.stopPropagation();

        let { width, height, left, top } = this.state;

        this.startWidth = width;
        this.startLeft = left;
        this.startHeight = height;
        this.startTop = top;

        this.setState({
            showMask: true,
        })

        document.body.classList.add('user-select-none');
    }

    onResizeStop = () => {
        this.setState({
            showMask: false,
        });
        this.resetDragHandlerWidth();
        document.body.classList.remove('user-select-none');
    }
}

export default withRouter(XiaoYou);